<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Keywords Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Keywords</li>
        <li class="active">Keywords List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Keywords List</h3>
              <div class="action-button pull-right">  
                <!-- <input type="button" :disabled="loading" class="btn btn-primary mrgn-right-20px" value="Add Keyword" v-on:click="showModal()" /> -->
                <router-link class="btn btn-primary" :to="`NewKeywordsDetails`">Add Keyword</router-link>
              </div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>

            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="keywordData"
                    :totalRows="keywordCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: 20
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-keyboard-o" title="No keywords found" hint="Try changing the filters, or create a new keyword." action-label="Create keyword" action-to="/NewKeywordsDetails" /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />

                        <span v-if="props.column.field == 'createdAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'copy'">
                          <router-link :to="`NewKeywordsDetails?keywordId=${props.row.id}&action=copyKeyword`">
                            <i class="fa fa-copy" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`NewKeywordsDetails?keywordId=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else-if="props.column.field == 'delete'">
                          <i class="fa fa-times-circle" aria-hidden="true" v-on:click="showDeleteConfirmationPopup(props.row, props.index)"></i>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
      <deleteConfirmationModal
        v-if="isDeleteConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteKeyword="deleteKeyword"
        :isDeleteConfirmationVisible="isDeleteConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />

    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import flatPickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import api from '../../../utils/api'
import addKeywordModal from './../popup/addKeyword'
import deleteConfirmationModal from './../popup/deleteConfirmation'
import { formatDate, getSelectorValue } from '../../../utils/utilities'

export default {
  name: 'KeywordDashboard',
  components: {
    'addKeywordModal': addKeywordModal,
    'deleteConfirmationModal': deleteConfirmationModal,
    flatPickr
    // 'jw-pagination': JwPagination
  },
  mounted () {
    // this.getKeywordsFromGoogleSheet()
    this.getAllKeywordsFromDB()
    this.loadApps(true)
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true
    })
  },
  data () {
    return {
      formatDate: formatDate,
      keywordObj: {},
      loading: true,
      actionInProgress: false,
      isModalVisible: false,
      isDeleteConfirmationVisible: false,
      validationErrors: [],
      keywordData: [],
      keywordCount: 0,
      clonedKeywordData: [],
      conversationApps: [],
      googleSheetInfoAndWorksheets: [],
      actionToBePerformed: 'Add Keyword',
      confirmationMessage: 'Are you sure you want to delete this keyword?',
      rowIndexToBeUpdated: 0,
      defaultRowObj: {
        id: null,
        keyword: '',
        conversation: '',
        type: '',
        product: '',
        appPackage: '',
        locationid: '',
        channel: '',
        language: '',
        facilities: '',
        campaign: '',
        messages: '',
        attachedfacilities: '',
        client: '',
        overrideuserlocation: '',
        createdAt: '',
        autoaccepttnc: false
      },
      gRowObj: {
        id: null,
        keyword: '',
        conversation: '',
        type: '',
        product: '',
        appPackage: '',
        locationid: '',
        channel: '',
        language: '',
        facilities: '',
        campaign: '',
        messages: '',
        attachedfacilities: '',
        client: '',
        overrideuserlocation: '',
        createdAt: '',
        autoaccepttnc: false
      },
      tableQueryParams: {
        columnFilters: {isdeleted: false},
        sort: {
          createdAt: -1
        },
        page: 1,
        perPage: 20
      },
      columns: [
        {
          label: 'Keyword',
          field: 'keyword',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Keyword'
          }
        },
        {
          label: 'Country',
          field: 'data.country',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Country'
          }
        },
        {
          label: 'Customer',
          sortable: true,
          field: 'data.client',
          filterOptions: {
            enabled: true,
            placeholder: 'Search Customer'
          }
        },
        {
          label: 'Conversation',
          field: 'data.conversation',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Conversation'
          }
        },
        {
          label: 'Created On',
          field: 'createdAt',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Copy',
          field: 'copy',
          sortable: false
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false
        },
        {
          label: 'Delete',
          field: 'delete',
          sortable: false
        }
      ],
      previousQueryParams: {}
    }
  },
  methods: {
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getAllKeywordsFromDB()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getAllKeywordsFromDB()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType === 'asc' ? 1 : -1
        }
      })
      this.getAllKeywordsFromDB()
    },
    onColumnFilter (params) {
      let appliedFilter = {isdeleted: false}
      for (const key in params.columnFilters) {
        if (key === 'createdAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['createdFromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['createdToDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getAllKeywordsFromDB()
    },

    loadApps (deployed = false) {
      let url = 'app'
      // url += deployed ? '?deployed=1' : ''
      api.buildRequest(url, 'GET')
        .then(response => {
          if (response.status === 200) {
            if (deployed) {
              this.conversationApps = response.data.payload.apps
            } else {
              this.conversationApps = response.data.payload.apps
            }
            console.log(this.conversationApps)
          }
        })
    },
    showModal () {
      this.validationErrors = []
      this.isModalVisible = true
    },
    /**
     * @function closeConfirmationModal
     * @description Function to close delete confirmation popup
     */
    closeConfirmationModal () {
      this.isDeleteConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    /**
     * @function closeModal
     * @description Function to close modal and reset all the variables
     */
    closeModal () {
      console.log('inside closeModal function')
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isDeleteConfirmationVisible = false
      this.validationErrors = []
      this.gRowObj = Object.assign({}, this.resetGRowObj())
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    showDeleteConfirmationPopup (keywordData, index) {
      console.log('inside showDeleteConfirmationPopup')
      this.actionToBePerformed = 'Delete Keyword'
      this.confirmationMessage = 'Are you sure you want to delete this keyword?'
      this.isDeleteConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },

    /**
     * @function getDataFromGoogleSheet
     * @description Get Keywords from Google sheet
     */
    getAllKeywordsFromDB (fromDeleteKeyword = false) {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams) && !fromDeleteKeyword) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }

      api.buildRequest('getAllKeywordsFromDB', 'POST', queryParams)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.previousQueryParams = queryParams
              if (response.data.payload.keywords.length > 0) {
                this.keywordData = response.data.payload.keywords
                this.clonedKeywordData = this.keywordData
                this.keywordCount = response.data.payload.keywordCount
              } else {
                this.keywordData = []
                this.clonedKeywordData = this.keywordData
                // this.getKeywordsFromGoogleSheet()
              }
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @function getInfoAndWorksheets
     * @description Get Info and Worksheets from Google Spreadsheet
     */
    getInfoAndWorksheets () {
      console.log('inside getInfoAndWorksheets function')
      this.loading = true
      // this.config['stages'] = this.stages
      api.buildRequest('getDataFromGoogleSheetByTitle', 'POST', {sheetReference: 'messagesForApps', sheetTitle: 'APP_LAUNCH'})
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.googleSheetInfoAndWorksheets = response.data.payload.data
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },

    /**
     * @description Display Keyword data in Popup
     */
    // showRowData (keywordData, index) {
    //   this.rowIndexToBeUpdated = index
    //   this.validationErrors = []
    //   this.actionToBePerformed = 'Update Keyword'
    //   console.log('keyword=', JSON.stringify(keywordData))
    //   console.log('inside editRowInGoogleSheet function')
    //   let keywordObj = keywordData.data
    //   console.log('keyword=', JSON.stringify(keywordObj))
    //   console.log('conversation=', keywordObj.conversation)
    //   if (keywordObj.conversation !== undefined) {
    //     let convIdx = _.findIndex(this.conversationApps, { 'name': keywordObj.conversation })
    //     console.log('conversation index', convIdx)
    //     if (convIdx !== -1) {
    //       this.gRowObj.conversation = keywordObj.conversation
    //     }
    //   }
    //   this.gRowObj.id = keywordData.id
    //   this.gRowObj.keyword = keywordObj.keyword
    //   this.gRowObj.type = keywordObj.type
    //   this.gRowObj.product = keywordObj.product || 'asknivi'
    //   this.gRowObj.appPackage = keywordObj.appPackage || 'conversation'
    //   this.gRowObj.channel = keywordObj.channel || ''
    //   this.gRowObj.language = keywordObj.language || 'eng'
    //   this.gRowObj.autoaccepttnc = keywordObj.autoaccepttnc || false
    //   this.gRowObj.createdAt = keywordData.createdAt
    //   this.gRowObj.facilities = keywordObj.facilities || ''
    //   this.showModal()
    // },
    /**
     * @author Sarang Sutar <sarang.sutar@mobifillia.com>
     * @description Update Keyword in Google Sheet
     * @param {Object} keywordData Keyword to be updated
     */
    updateKeyword (keywordData) {
      this.actionInProgress = true
      console.log('updating row in the google sheet')
      console.log(this.rowIndexToBeUpdated)
      console.log(this.gRowObj)
      let trimmedObj = {}
      trimmedObj = this.trimJsonObj(this.gRowObj)
      const newRowObj = {
        id: trimmedObj.id,
        createdAt: trimmedObj.createdAt,
        data: trimmedObj
      }
      // this.clonedKeywordData[this.rowIndexToBeUpdated] = Object.assign({}, newRowObj)
      this.clonedKeywordData.splice(this.rowIndexToBeUpdated, 1, newRowObj)
      console.log('updated data')
      console.log(this.clonedKeywordData)
      this.keywordData = this.clonedKeywordData
      const googleSheetRowOffset = this.rowIndexToBeUpdated + 1
      const params = {
        sheetReference: 'keyword',
        workSheetIndex: 1,
        updatedRow: trimmedObj,
        options: {
          offset: googleSheetRowOffset,
          limit: 1
        },
        sheetData: this.keywordData
      }
      var self = this
      api.buildRequest('updateKeyword', 'POST', params)
          .then(response => {
            this.actionInProgress = false
            if (response.status === 200) {
              self.isModalVisible = false
              self.closeModal()
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Keyword updated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.isModalVisible = false
            self.closeModal()
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @author Sarang Sutar <sarang.sutar@mobifillia.com>
     * @description Add Keyword in Google Sheet
     * @param {Object} keywordData Keyword to be updated
     */
    addKeyword (keywordData) {
      this.actionInProgress = true
      console.log('addKeyword')
      console.log(this.rowIndexToBeUpdated)
      let trimmedObj = {}
      trimmedObj = this.trimJsonObj(this.gRowObj)
      console.log(trimmedObj)
      const newRowObj = {
        id: trimmedObj.id,
        data: trimmedObj
      }
      newRowObj.isdeleted = false
      newRowObj.createdAt = new Date()
      this.clonedKeywordData.unshift(newRowObj)
      this.keywordData = this.clonedKeywordData
      const params = {
        sheetReference: 'keyword',
        workSheetIndex: 1,
        newRow: trimmedObj,
        sheetData: this.keywordData
      }
      var self = this
      api.buildRequest('addKeyword', 'POST', params)
          .then(response => {
            self.actionInProgress = false
            self.closeModal()
            if (response.status === 200) {
              self.isModalVisible = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Keyword added to Google Sheet successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.isModalVisible = false
            self.actionInProgress = false
            self.closeModal()
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @author Sarang Sutar <sarang.sutar@mobifillia.com>
     * @description Delete Keyword in Google Sheet
     * @param {Object} keywordData Keyword to be updated
     */
    deleteKeyword () {
      this.loading = true
      console.log('deleteKeyword')
      console.log('index')
      console.log(this.rowIndexToBeUpdated)
      const deletedRowData = this.keywordData[this.rowIndexToBeUpdated]
      this.keywordData.splice(this.rowIndexToBeUpdated, 1)
      console.log('spliced keywordData')
      console.log(this.keywordData)
      const params = {
        sheetReference: 'keyword',
        workSheetIndex: 2,
        sheetData: this.keywordData,
        deletedRow: deletedRowData
      }
      var self = this
      api.buildRequest('deleteKeyword', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            self.closeModal()
            if (response.status === 200) {
              self.isDeleteConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response ? response.data.payload.message : 'Keyword deleted successfully'
              }).then(() => {
                this.getAllKeywordsFromDB(true)
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isDeleteConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    /**
     * @author Sarang Sutar <sarang.sutar@mobifillia.com>
     * @description Reset Row Data
     */
    resetGRowObj () {
      console.log('inside resetGRowObj method')
      return this.defaultRowObj
    },
    /**
     * @author Sarang Sutar <sarang.sutar@mobifillia.com>
     * @description Trim JSON Object
     */
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key])
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      return trimmedObj
    },
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    sortKeywords (sortKey, order) {
      this.keywordData = _.sortBy(this.keywordData, [sortKey])
      if (order === 'desc') {
        this.keywordData = _.reverse(this.keywordData)
      }
      console.log(`sorted keywords=${this.keywordData}`)
    }
  }
}
</script>
<style>
.vgt-inner-wrap.is-loading {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.good-table td {
  white-space: normal;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
</style>


// WEBPACK FOOTER //
// keywordsList.vue?c3dc4122